import * as React from "react"

const SectionTitle = ({ level, title, size, className }) => {
  const TitleTag = level ? `h${level}` : "h2"

  return (
    <TitleTag
      className={`${size ? size : "text-2xl"} uppercase mb-4 ${className}`}
    >
      {title}
    </TitleTag>
  )
}

export default SectionTitle
